import { WrapperEntryName } from '@/interfaces';
import dynamic from 'next/dynamic';

export const WrapperEntryMapping: {
  // biome-ignore lint/suspicious/noExplicitAny: dynamic component map requires any props
  [key in WrapperEntryName]?: React.ComponentType<any>;
} = {
  [WrapperEntryName.ContentItem]: dynamic(async () => import('../components/Wrapper/ContentItems')),
};
